import { render, staticRenderFns } from "./ChinaArea.vue?vue&type=template&id=67fb9f95&scoped=true"
import script from "./ChinaArea.vue?vue&type=script&lang=js"
export * from "./ChinaArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fb9f95",
  null
  
)

export default component.exports